import HeaderWithSideNav from "src/Components/HeaderWithSideNav";
import VoucherFromLayout from "src/Layouts/VoucherForm";

const VoucherFormPage = () => {
  return (
    <div>
      <HeaderWithSideNav />
      <main className="pl-72">
        <div>
          <VoucherFromLayout />
        </div>
      </main>
    </div>
  );
};

export default VoucherFormPage;
